import { api } from 'api'
import { ErrorsNoData } from 'constants/actionMessages'
import { getCreatorAsyncSlice } from 'modules/store'

import { RootState } from '..'

const { createAsyncSlice } = getCreatorAsyncSlice<RootState>({ nameReducer: 'dataSourceFields' })

export const { getDataSourceFields, selectDataSourceFields, initialSliceDataSourceFields, sliceCasesDataSourceFields } =
  createAsyncSlice({
    nameAction: 'getDataSourceFields',
    nameSlice: 'dataSourceFields',
    promise: api.dataSourceFields.getAll,
    error: ErrorsNoData.DataSourceFields,
  })
